import { Button, Card, CardActions } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { hideProcessing, showProcessing } from "./reducer/ProcessingSlice";
import api, { REQUEST_METHOD } from "./common/api";
import { loadScan } from "./reducer/LaserDataSlice";

/**
 * Scan Analysis's Apply / Apply & Save footer - split out of CalculationContainer so it can be
 * pinned to the bottom of the rail (VisualizerContent.js) instead of scrolling away with the
 * Positions/Surface Correction/Filters cards above it.
 */
export default function CalculationActions(props)
{
    const { onApply, onApplied } = props;
    const laserData = useSelector(state => state.laserData);
    const calcSettings = useSelector(state => state.calcSettings);
    const { getAccessTokenSilently } = useAuth0();
    const dispatch = useDispatch();

    const handleApply = async (isSaved) => {
        try {
            if(onApply) {
                onApply();
            }
            dispatch(showProcessing({message: "Applying changes..."}));

            let token = await getAccessTokenSilently();
            new api().request(`/datavisualizer/${laserData.id}`, token, REQUEST_METHOD.POST, {settings: calcSettings.changes, save: isSaved})
            .then(async (data) => {
                await dispatch(loadScan({
                    id: laserData.id,
                    scan: data
                })).unwrap();

                if(onApplied) {
                    onApplied();
                }
            })
            .catch(err => {
                console.log("error: ", err);
            })
            .finally(() => {
                dispatch(hideProcessing());
            })
        } catch (err) {
            console.error();
            dispatch(hideProcessing());
        }
    }

    return (
        <Card>
            {/* Two separate, always-visible buttons per the mockup - not a single
                split-button choosing between them via a dropdown. */}
            <CardActions sx={{justifyContent:"end",paddingRight:"8px"}}>
                <Button
                    variant="outlined"
                    color="inherit"
                    disabled={!calcSettings.dirty || calcSettings.error}
                    onClick={() => handleApply(false)}
                >
                    Apply
                </Button>
                <Button
                    variant="contained"
                    disabled={!calcSettings.dirty || calcSettings.error}
                    onClick={() => handleApply(true)}
                >
                    Apply &amp; Save
                </Button>
            </CardActions>
        </Card>
    );
}
